import { Component } from '@angular/core';

@Component({
  selector: 'app-waitron-admin-shell-layout',
  standalone: false,
  templateUrl: './waitron-admin-shell-layout.component.html',
  styleUrl: './waitron-admin-shell-layout.component.scss'
})
export class WaitronAdminShellLayoutComponent {

}
